<template>
    <div>
        <p>THERE'S BEEN AN ERROR!</p>
    </div>
</template>

<script>
    import common from '../modules/common'

    export default {
        mounted() {
            var bc = common.breadcrumb.create([
                { url: '/', text: 'UtterAccess' },
                { text: 'Error' }
            ]);
            this.$store.dispatch("breadcrumb", bc);
        }
    }
</script>